module.exports = __webpack_public_path__ + "img/DNADamage-GBM_SPATA.cd26ec8d.png";